const API_URL = 'https://api.haconti.com';
const CHAIN_ID = 11155111; // Sepolia
//const CHAIN_ID = 31337; // localhost

export { API_URL, CHAIN_ID };